import { PlusOutlined, StarOutlined } from '@ant-design/icons';
import { Button, Card, message, Upload } from 'antd';
import { Form } from 'antd';
import { useContext, useState } from 'react';
import { useAuth } from '../../../../../store/AuthContext/AuthContext';
import { updatePics } from '../../../../../services/updatePics';
import { UploadFile } from 'antd/lib/upload/interface';
import { IUploadProps, InfoArgs } from '../../../../../types/updates';
import { Typography } from 'antd';
import Title from 'antd/lib/typography/Title';
import { useTranslation } from 'react-i18next';
import { GlobalVariableContext } from '../../../../../store/GlobalVariableContext/GlobalVariableContext';
const { Text } = Typography;

interface Props {
  onFinish: () => void,
  selectedKeys: Array<string>,
  label?: any,
  textBtn: string,
  category: string
}

const UploadUniqueInput = ({onFinish, selectedKeys, label, textBtn, category}: Props): JSX.Element => {

  const { t } = useTranslation();
  const { token, projectGroup } = useAuth();
  const [ formLogo ] = Form.useForm();
	const [uploadFileList, setUploadFileList] = useState<Array<UploadFile>>([]);

  const {updateGlobalImage , setUpdateGlobalImage} = useContext(GlobalVariableContext)

  const resolutionLogo: string = t('view.forms.fields.photo.info.resolution.logo');
  const resolutionCover: string = t('view.forms.fields.photo.info.resolution.cover');

  const onUploadChange = (info: InfoArgs): void => {
    
    if (info?.fileList.length > 0) {
      
      if (
        info?.fileList[0]?.size! >= 5000000 ||
        info?.fileList[0]?.size! <= 10000

        ) {
        message.error(t('view.forms.fields.photo.errors.size'), 3)
        return
      }
      if (
        info?.fileList[0]?.type! !== "image/png" &&
        info?.fileList[0]?.type! !== "image/jpeg" &&
        info?.fileList[0]?.type! !== "image/jpg"
      ) {
        message.error(t('view.forms.fields.photo.errors.extension'), 3)
        return
      }
    }

    let fileList = [...info.fileList];
    fileList = fileList.slice(-1 * 1)
		fileList = fileList.map(file => {
			if (file.response) {
				file.url = file.response.url;
			}
			return file;
		});
		setUploadFileList(fileList);		
	}

	const uploadProps: IUploadProps = {
		action: `${process.env.REACT_APP_API}/projects/${projectGroup.project}/media`,
		accept: 'image/jpeg,image/png,image/jpg',
		headers: {
			Authorization: 'Bearer ' + token
		},		 
		onChange: onUploadChange,
		multiple: true,		 
		fileList: uploadFileList,
	};

  	const submitMedia = async (values: any) => {
      try {
        
        //const url: string = values.photo.fileList[0].url;
        const photosURL: string[] = values.photo.fileList.map((file: any) => file.url);

        const data = {
          category,
          photosURL,
          locationsNames: selectedKeys
        };
        await updatePics({ 
          config: { method: 'POST', data }, 
          url: `${process.env.REACT_APP_API}/projects/${projectGroup.project}/${projectGroup.group}/locations/localPostMedia`
        })
        message.success(t('view.forms.fields.photo.success'), 3)
        setUpdateGlobalImage(!updateGlobalImage);
        onFinish() 
        setUploadFileList([])
      } catch (error: any) {
        message.error(t('view.forms.fields.photo.errors.edit'), 3)
      }
    };

  return (
    <>
    <Form
      layout='vertical'
      form={formLogo}
      onFinish={submitMedia}
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
        width: '100%'
      }}
    >
      {/* Campo de imagen y restricciones en la misma fila */}
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', justifyContent:'space-between', width: '100%', gap: 24 }}>
        <Form.Item
          //label={label}
          name='photo'
          style={{ marginLeft: '10px' }}
        >
          <Upload {...uploadProps} listType='picture-card'>
            {
              uploadFileList.length < 1 && (
                <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontWeight: 600,
                  color: '#4176fa',
                  padding: 12,
                  border: '2px dashed #4176fa',
                  borderRadius: 8,
                  background: '#f0f7ff',
                  //boxShadow: '0 2px 8px rgba(65, 118, 250, 0.10)'
                }}>
                  <PlusOutlined style={{ fontSize: 32, color: '#4176fa' }} />
                  <div style={{ fontSize: 17, color: '#4176fa' }}>
                    {label}
                  </div>
                </div>
              )
            }
          </Upload>
        </Form.Item>

        {/* Restricciones a la derecha */}
        <div style={{ maxWidth: 350, flex: 1 }}>
          <Card 
            size="small" 
            style={{ 
              background: '#FFF7EC', 
              border: '1px solid #ffe3ba', 
              fontSize: '0.93em' 
            }}
          >
            <div>
              <Title 
                level={5} 
                style={{ 
                  marginBottom: 8, 
                  fontWeight: 500, 
                  color: "#a86c12", 
                  background: 'transparent' 
                }}
              >
                {t('dictionary.requirements')}
              </Title>
              <Text>
                {t('dictionary.format')}: {t('view.forms.fields.photo.info.format')}.<br />
                {t('dictionary.size')}: {t('view.forms.fields.photo.info.size')}.<br />
                {t('dictionary.resolution')}: {category === "LOGO" ? resolutionLogo : resolutionCover}
              </Text>
            </div>
          </Card>
        </div>
   
      </div>

      {/* Botón debajo centrado a la derecha */}
      <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end', width: '100%' }}>
        <Button
          disabled={uploadFileList.length <= 0}
          shape='round'
          type='primary'
          onClick={formLogo.submit}
          style={{ minWidth: 140, marginLeft: '1rem' }}
        >
          {textBtn}
        </Button>
      </div>
    </Form>
    </>
						
	)
};

export default UploadUniqueInput
